export enum FeatureFlag {
    CREDIT_CALCULATOR = 'creditCalculator',
    MARKETING_CONSENT_TYPES = 'marketingConsentTypes',
    INSURANCE_NEW_VIEW = 'insuranceNewView',
}

/**
 * Проверка включенности фича-флага.
 */
export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
    const value = (window as any).env?.FEATURE_FLAGS?.[flag];

    return value === true || value === 'true';
};
